import Vue from "vue";
import App from "./App";
import Axios from "axios";
import VueRouter from "vue-router";
import BootstrapVue from "bootstrap-vue";
import { routes } from "./routes/index";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";
import "./assets/css/style.css";
import "./assets/css/default.css";
import VueCookies from "vue-cookies";
import VScrollLock from 'v-scroll-lock'
import vueTopprogress from 'vue-top-progress'

Vue.use(vueTopprogress)
Vue.use(VScrollLock)
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Axios);
Vue.use(VueCookies);

Vue.config.productionTip = false;

const router = new VueRouter({
  routes,
  mode: "history"
});

new Vue({
  el: "#app",
  data: {
    idParticipante: ''
  },
  router,
  render: h => h(App)
});
